import * as yup from 'yup'

export interface homePageSchema {
  dateOfBirth: string | null
}

export const homePageSchemaValidation = yup.object().shape({
  dateOfBirth: yup.date().nullable().required('日付は必須です'),
})
